import { render, staticRenderFns } from "./NoMortgageDataUploadPage.vue?vue&type=template&id=4c3135d4&scoped=true"
import script from "./NoMortgageDataUploadPage.vue?vue&type=script&lang=js"
export * from "./NoMortgageDataUploadPage.vue?vue&type=script&lang=js"
import style0 from "./NoMortgageDataUploadPage.vue?vue&type=style&index=0&id=4c3135d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3135d4",
  null
  
)

export default component.exports